import React from 'react'
import ProductListContainer from './ProductListContainer'

export default function ProductListScreen() {
    return <ProductListContainer />
}
